import z from "zod";

export const LANGUAGES = ["en", "es", "ca"] as const;

export const languageSchema = z.enum(LANGUAGES);
export type Language = z.infer<typeof languageSchema>;

export const DEFAULT_LANGUAGE: Language = "es";
